import script from "./Welcome.vue?vue&type=script&setup=true&lang=js"
export * from "./Welcome.vue?vue&type=script&setup=true&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=e040d428&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e040d428"]])

export default __exports__